import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "square"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#square" }),
  /*#__PURE__*/_createTextVNode(" Square Badge ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("code", null, ".badge-square"),
  /*#__PURE__*/_createTextVNode(" class to use a badge with same width and height: ")
], -1)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = { class: "rounded border p-10 pb-0 d-flex flex-wrap align-items-center" }
const _hoisted_6 = { class: "py-5" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`<span class="badge badge-square badge-white">5</span>
        <span class="badge badge-square badge-primary">5</span>
        <span class="badge badge-square badge-light">5</span>
        <span class="badge badge-square badge-secondary">5</span>
        <span class="badge badge-square badge-success">5</span>
        <span class="badge badge-square badge-info">5</span>
        <span class="badge badge-square badge-warning">5</span>
        <span class="badge badge-square badge-danger">5</span>
        <span class="badge badge-square badge-dark">5</span>`))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors, (item, i) => {
          return (_openBlock(), _createBlock("span", {
            key: i,
            class: "d-flex p-2 bg-dark me-10 mb-10"
          }, [
            _createVNode("span", {
              class: [`badge-${item}`, "badge badge-square"]
            }, "5", 2)
          ]))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      })
    ])
  ]))
}